import api from "../../services/api";
import { GET_CHAPTERS_BY_MODULE_ID_REQUEST } from "../Chapter/ActionType";
import {
  ADD_COURSE_FAILURE,
  ADD_COURSE_REQUEST,
  ADD_COURSE_SUCCESS,
  GET_COMPLETE_COURSE_DETAIL_FAILURE,
  GET_COMPLETE_COURSE_DETAIL_REQUEST,
  GET_COMPLETE_COURSE_DETAIL_SUCCESS,
  GET_COURSES_FAILURE,
  GET_COURSES_REQUEST,
  GET_COURSES_SUCCESS,
  GET_COURSE_BY_ID_FAILURE,
  GET_COURSE_BY_ID_REQUEST,
  GET_COURSE_BY_ID_SUCCESS,
  GET_COURSE_NESTED_DETAIL_FAILURE,
  GET_COURSE_NESTED_DETAIL_REQUEST,
  GET_COURSE_NESTED_DETAIL_SUCCESS,
  GET_MY_COURSES_FAILURE,
  GET_MY_COURSES_REQUEST,
  GET_MY_COURSES_SUCCESS,
  GET_MY_LEARNING_FAILURE,
  GET_MY_LEARNING_REQUEST,
  GET_MY_LEARNING_SUCCESS,
  RESET_COURSE_APPROVAL_STATUS,
  UPDATE_COURSE_APPROVAL_STATUS_FAILURE,
  UPDATE_COURSE_APPROVAL_STATUS_REQUEST,
  UPDATE_COURSE_APPROVAL_STATUS_SUCCESS,
  GET_BASIC_COURSE_DETAIL_FAILURE,
  GET_BASIC_COURSE_DETAIL_REQUEST,
  GET_BASIC_COURSE_DETAIL_SUCCESS,
  UPDATE_COURSE_FAILURE,
  UPDATE_COURSE_REQUEST,
  UPDATE_COURSE_SUCCESS,
  SEARCH_APPROVED_COURSES_FAILURE,
  SEARCH_APPROVED_COURSES_REQUEST,
  SEARCH_APPROVED_COURSES_SUCCESS,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST,
  GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS,
} from "./ActionType";

const addCourseRequest = () => ({ type: ADD_COURSE_REQUEST });
const addCourseSuccess = (course) => ({
  type: ADD_COURSE_SUCCESS,
  payload: course,
});
const addCourseFailure = (error) => ({
  type: ADD_COURSE_FAILURE,
  payload: error,
});

export const addCourse = (request) => async (dispatch) => {
  dispatch(addCourseRequest());
  try {
    const response = await api.post(`/courses`, request.courseData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 600000, // 10 minutes for course creation with image uploads
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    const newCourse = response.data;
    request.navigate(`/module?courseId=${newCourse.id}`);
    dispatch(addCourseSuccess(newCourse));
  } catch (error) {
    dispatch(addCourseFailure(error.response.data));
  }
};

const getCoursesRequest = () => ({ type: GET_COURSES_REQUEST });
const getCoursesSuccess = (courseListResponse) => ({
  type: GET_COURSES_SUCCESS,
  payload: courseListResponse,
});

const getCoursesFailure = (error) => ({
  type: GET_COURSES_FAILURE,
  payload: error,
});

export const getCourses = (page, approvalStatus) => async (dispatch) => {
  dispatch(getCoursesRequest());
  try {
    const response = await api.get(
      `/courses?page=${page}&approvalStatus=${approvalStatus}`
    );
    const courseListResponse = response.data;
    dispatch(getCoursesSuccess(courseListResponse));
  } catch (error) {
    dispatch(getCoursesFailure(error.response.data));
  }
};

// Fetch publicly visible courses for landing page
export const getPublicCourses = () => async (dispatch) => {
  dispatch(getCoursesRequest());
  try {
    const response = await api.get(`/courses/public`);
    const courseListResponse = response.data;
    dispatch(getCoursesSuccess(courseListResponse));
  } catch (error) {
    dispatch(getCoursesFailure(error.response?.data || error.message));
  }
};

// Public course complete details by courseId
const getPublicCourseCompleteDetailRequest = () => ({
  type: GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST,
});
const getPublicCourseCompleteDetailSuccess = (course) => ({
  type: GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS,
  payload: course,
});
const getPublicCourseCompleteDetailFailure = (error) => ({
  type: GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE,
  payload: error,
});

export const getPublicCourseCompleteDetail = (courseId) => async (dispatch) => {
  dispatch(getPublicCourseCompleteDetailRequest());
  try {
    const response = await api.get(`/courses/public/${courseId}/complete-detail`);
    dispatch(getPublicCourseCompleteDetailSuccess(response.data));
  } catch (error) {
    dispatch(getPublicCourseCompleteDetailFailure(error.response?.data || error.message));
  }
};

const getCourseNestedDetailRequest = () => ({
  type: GET_COURSE_NESTED_DETAIL_REQUEST,
});

const getCourseNestedDetailSuccess = (course) => ({
  type: GET_COURSE_NESTED_DETAIL_SUCCESS,
  payload: course,
});

const getCourseNestedDetailFailure = (error) => ({
  type: GET_COURSE_NESTED_DETAIL_FAILURE,
  payload: error,
});

export const getCourseNestedDetail = (courseId) => async (dispatch) => {
  dispatch(getCourseNestedDetailRequest());
  try {
    const response = await api.get(`/courses/${courseId}/nested-detail`);
    const course = response.data;
    dispatch(getCourseNestedDetailSuccess(course));
  } catch (error) {
    dispatch(getCourseNestedDetailFailure(error.response.data));
  }
};

const updateCourseApprovalStatusRequest = () => ({
  type: UPDATE_COURSE_APPROVAL_STATUS_REQUEST,
});

const updateCourseApprovalStatusSuccess = (course) => ({
  type: UPDATE_COURSE_APPROVAL_STATUS_SUCCESS,
  payload: course,
});

const updateCourseApprovalStatusFailure = (error) => ({
  type: UPDATE_COURSE_APPROVAL_STATUS_FAILURE,
  payload: error,
});

export const updateCourseApprovalStatus =
  (courseId, status) => async (dispatch) => {
    dispatch(updateCourseApprovalStatusRequest());
    try {
      const response = await api.patch(`/courses/${courseId}/approval-status`, {
        approvalStatus: status,
      });
      const updatedCourse = response.data;
      dispatch(updateCourseApprovalStatusSuccess(updatedCourse));
    } catch (error) {
      dispatch(updateCourseApprovalStatusFailure(error.response.data));
    }
  };

export const resetCourseApprovalStatus = () => ({
  type: RESET_COURSE_APPROVAL_STATUS,
});

const getCompleteCourseDetailRequest = () => ({
  type: GET_COMPLETE_COURSE_DETAIL_REQUEST,
});

const getCompleteCourseDetailSuccess = (course) => ({
  type: GET_COMPLETE_COURSE_DETAIL_SUCCESS,
  payload: course,
});

const getCompleteCourseDetailFailure = (error) => ({
  type: GET_COMPLETE_COURSE_DETAIL_FAILURE,
  payload: error,
});

export const getCompleteCourseDetail = (courseId) => async (dispatch) => {
  dispatch(getCompleteCourseDetailRequest());
  try {
    const response = await api.get(`/courses/${courseId}/complete-detail`);
    const course = response.data;
    dispatch(getCompleteCourseDetailSuccess(course));
  } catch (error) {
    dispatch(getCompleteCourseDetailFailure(error.response.data));
  }
};

const getCourseByIdRequest = () => ({
  type: GET_COURSE_BY_ID_REQUEST,
});

const getCourseByIdSuccess = (course) => ({
  type: GET_COURSE_BY_ID_SUCCESS,
  payload: course,
});

const getCourseByIdFailure = (error) => ({
  type: GET_COURSE_BY_ID_FAILURE,
  payload: error,
});

export const getCourseById = (courseId) => async (dispatch) => {
  dispatch(getCourseByIdRequest());
  try {
    const response = await api.get(`/courses/${courseId}`);
    const course = response.data;
    dispatch(getCourseByIdSuccess(course));
  } catch (error) {
    dispatch(getCourseByIdFailure(error.response.data));
  }
};

const getMyCourseRequest = () => ({
  type: GET_MY_COURSES_REQUEST,
});

const getMyCourseSuccess = (courses) => ({
  type: GET_MY_COURSES_SUCCESS,
  payload: courses,
});

const getMyCourseFailure = (error) => ({
  type: GET_MY_COURSES_FAILURE,
  payload: error,
});

export const getMyCourses = (page) => async (dispatch) => {
  dispatch(getMyCourseRequest());
  try {
    const response = await api.get(`/courses/my-courses?page=${page}`);
    const courses = response.data;
    dispatch(getMyCourseSuccess(courses));
  } catch (error) {
    dispatch(getMyCourseFailure(error.response.data));
  }
};

const getMyLearningRequest = () => ({
  type: GET_MY_LEARNING_REQUEST,
});
const getMyLearningSuccess = (learningCourses) => ({
  type: GET_MY_LEARNING_SUCCESS,
  payload: learningCourses,
});
const getMyLearningFailure = (error) => ({
  type: GET_MY_LEARNING_FAILURE,
  payload: error,
});
export const getMyLearning = (page) => async (dispatch) => {
  dispatch(getMyLearningRequest());
  try {
    const response = await api.get(`/courses/my-learning?page=${page}`);
    const learningCourses = response.data;
    dispatch(getMyLearningSuccess(learningCourses));
  } catch (error) {
    dispatch(getMyLearningFailure(error.response.data));
  }
};

const getBasicCourseDetailRequest = () => ({
  type: GET_BASIC_COURSE_DETAIL_REQUEST,
});

const getBasicCourseDetailSuccess = (course) => ({
  type: GET_BASIC_COURSE_DETAIL_SUCCESS,
  payload: course,
});

const getBasicCourseDetailFailure = (error) => ({
  type: GET_BASIC_COURSE_DETAIL_FAILURE,
  payload: error,
});

export const getBasicCourseDetail = (courseId) => async (dispatch) => {
  dispatch(getBasicCourseDetailRequest());
  try {
    const response = await api.get(`/courses/${courseId}/basic-details`);
    const course = response.data;
    dispatch(getBasicCourseDetailSuccess(course));
  } catch (error) {
    dispatch(getBasicCourseDetailFailure(error.response?.data || error.message));
  }
};

const updateCourseRequest = () => ({
  type: UPDATE_COURSE_REQUEST,
});

const updateCourseSuccess = (course) => ({
  type: UPDATE_COURSE_SUCCESS,
  payload: course,
});

const updateCourseFailure = (error) => ({
  type: UPDATE_COURSE_FAILURE,
  payload: error,
});

export const updateCourse = (courseId, courseData) => async (dispatch) => {
  dispatch(updateCourseRequest());
  try {
    const response = await api.put(`/courses/${courseId}`, courseData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 600000, // 10 minutes for course updates with image uploads
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    const updatedCourse = response.data;
    dispatch(updateCourseSuccess(updatedCourse));
    return updatedCourse;
  } catch (error) {
    dispatch(updateCourseFailure(error.response?.data || error.message));
    throw error;
  }
};

const searchApprovedCoursesRequest = () => ({
  type: SEARCH_APPROVED_COURSES_REQUEST,
});

const searchApprovedCoursesSuccess = (courseListResponse) => ({
  type: SEARCH_APPROVED_COURSES_SUCCESS,
  payload: courseListResponse,
});

const searchApprovedCoursesFailure = (error) => ({
  type: SEARCH_APPROVED_COURSES_FAILURE,
  payload: error,
});

export const searchApprovedCourses = (namePrefix, page, courseType) => async (dispatch) => {
  dispatch(searchApprovedCoursesRequest());
  try {
    const params = new URLSearchParams();
    if (namePrefix && namePrefix.trim() !== "") params.append("namePrefix", namePrefix.trim());
    if (courseType && courseType.trim() !== "") params.append("courseType", courseType.trim());
    params.append("page", page);

    const response = await api.get(`/courses/approved/search?${params.toString()}`);
    const courseListResponse = response.data;
    dispatch(searchApprovedCoursesSuccess(courseListResponse));
  } catch (error) {
    dispatch(searchApprovedCoursesFailure(error.response?.data || error.message));
  }
};
